<template>
    <div :id="id" class="home-module-chart"></div>
  </template>
  <script>
  const width = window.innerWidth / 1920;
  const height = window.innerHeight / 1080;
  export default {
    name: 'index',
    data () {
      return {
        id:
          'module-chart-' +
          Math.random()
            .toString(36)
            .slice(-8),
        chart: null,
        options: {
           data: [{
            title: '累计古籍数',
            value: [3000, 4000, 5000, 6000, 7000, 8000]
           }],
           xTick: [2019, 2020, 2021, 2022, 2023, 2024],
           unit: ''
        }
      };
    },
    methods: {
      setChart () {
        var option = {
          legend: {
            show: false,
            icon: 'circle',
            textStyle: {
                color: '#98a7c4'
            }
          },
          grid: {
            top: 30,
            right: 20,
            left: 60,
            bottom: 25 * height
          },
          tooltip: {
            trigger: 'item',
            axisPointer: {
              type: 'cross',
              crossStyle: {
                color: '#999'
              },
              label: {
                show: true,
                color: 'white'
              }
            }
          },
          xAxis: {
            type: 'category',
            data: this.options.xTick,
            axisLine: {
              show: true,
              lineStyle: {
                color: '#4D1A19'
              }
            },
            axisLabel: {
              color: '#4D1A19',
              fontSize: 13,
              width: 60 * width,
              overflow: 'break',
              interval: this.options.interval ? 0 : 'auto'
            },
            axisTick: {
              show: false
            }
          },
          yAxis: {
            axisLine: {
              show: false,
              lineStyle: {
                color: '#4D1A19'
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
              // lineStyle: {
              //   color: ['rgba(52, 60, 96, 1)']
              // }
            },
            name: this.options.unit,
            nameLocation: 'end',
            nameTextStyle: {
              color: '#4D1A19',
              align: 'right'
            },
            axisLabel: {
              color: '#4D1A19',
              fontSize: 12 * height
            }
          },
          series: this.options.data.map((item, index) => {
            let color = '#7C1823';
            return {
              name: item.title,
              type: 'bar',
              data: item.value,
              barMaxWidth: 30 * width,
              // color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, color),
              color,
              smooth: true,
              showSymbol: false,
              itemStyle: {
                borderRadius: 5
              }
            };
          })
        };
        this.chart.setOption(option);
      }
    },
    mounted () {
      this.chart = this.$echarts.init(document.getElementById(this.id), 'light');
      this.setChart();
      window.addEventListener('resize', () => {
        this.chart.resize();
      });
    }
  };
  </script>
  <style lang="less" scoped>
@import "~@/styles/variables.less";
  @import '~@/styles/variables.less';
  .home-module-chart {
    margin-top: 50 * @uh;
    width: 100%;
    height: 548px;
  }
  </style>
